export default "__VITE_ASSET__f430fda0__"